import { usePlatformTrial } from '@hooks/usePlatformTrial';
import { usePlanApprovalStore } from '@stores/planApprovalStore';

/**
 * Permanent "workspace is read-only" bar (PRD V6.0 ②) — mounted app-wide
 * (`DashboardLayout`) once the platform trial has lapsed without approval.
 * Not dismissible: the only way out is `ApprovePlanModal`, opened from here.
 *
 * `readOnly` is the ONLY field write-locks may branch on (see
 * `usePlatformTrial`'s doc comment) — this component reads nothing else.
 */
export function ReadOnlyBar() {
  const { readOnly, daysLeft } = usePlatformTrial();
  const open = usePlanApprovalStore(s => s.open);

  if (!readOnly) return null;

  // Same two causes as the banner: credits ran out before day 15 (days remain)
  // vs. day 15 arrived without approval (no days left).
  const message =
    daysLeft != null && daysLeft > 0
      ? "You've used all your free trial credits, so your workspace is read-only."
      : 'Your free trial is over, so your workspace is read-only.';

  return (
    <div
      data-testid="read-only-bar"
      className="flex w-full flex-shrink-0 flex-wrap items-center justify-center gap-3 bg-[#1b1464] px-4 py-2.5 text-center text-sm font-medium text-white"
    >
      <span>{message}</span>
      <button
        type="button"
        onClick={open}
        className="rounded-full bg-white/15 px-3 py-1 text-sm font-semibold text-white transition-colors hover:bg-white/25"
      >
        Approve plan
      </button>
    </div>
  );
}
